export default class Param {
    constructor(){

        this.breakpoint = 750;
        this.displayType = (window.innerWidth>this.breakpoint)?"pc":"sp";
        if(Useragnt.mobile){
            this.userAgent = "sp";
        }else if(Useragnt.tablet){
            this.userAgent = "tablet";
        }else{
            this.userAgent = "pc";
        }
        if(document.querySelector("html").classList.contains('ie') || document.querySelector("html").classList.contains('edge')){
            this.browserType = 'IE';
        }else if(document.querySelector("html").classList.contains('safari') && document.querySelector("html").classList.contains('pc')){
            this.browserType = 'safari';
        }else{
            this.browserType = 'other';
        }
        this.screenType = 'normal';
        this.videoLoaded = false; // [ 動画読み込んだかどうかの判定 ]

        this.webglLoaded = false; // [ webgl読み込んだかどうかの判定 ]
        this.webglAssets = {
            earthImgUrl: './assets/img/webgl/earth.png',
            imgURL: './assets/img/webgl/marcellus.png',
            jsonURLs: {
                modelA: './assets/img/webgl/A_madori.json',
                modelWireA: './assets/img/webgl/A_madori_wireframe.json',
                modelB: './assets/img/webgl/B_town_.json',
                modelWireB: './assets/img/webgl/B_town_wireframe.json',
                modelEarthWire: './assets/img/webgl/earth_wireframe.json',
                font: './assets/img/webgl/marcellus.json'
            }
        };

        this.youtube = {
            domID : "p-modal-content-screen",
            id    : "4azh4ihTZsY"
        }


    }
}
